import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ptr-indicator__pill" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "ptr-fade" }, {
    default: _withCtx(() => [
      ($setup.isPulling || $setup.isRefreshing)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "ptr-indicator",
            style: _normalizeStyle({ transform: `translateY(${$setup.translateY}px)` })
          }, [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["ptr-indicator__icon", { 'ptr-indicator__icon--spinning': $setup.isRefreshing }]),
                style: _normalizeStyle(!$setup.isRefreshing ? { transform: `rotate(${$setup.rotation}deg)`, opacity: $setup.opacity } : {}),
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, _cache[0] || (_cache[0] = [
                _createElementVNode("path", {
                  d: "M21 12a9 9 0 1 1-2.636-6.364",
                  stroke: "#1CA55C",
                  "stroke-width": "2.5",
                  "stroke-linecap": "round"
                }, null, -1 /* CACHED */)
              ]), 6 /* CLASS, STYLE */))
            ])
          ], 4 /* STYLE */))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}